import { createStore } from 'redux';
import { persistStore, persistCombineReducers } from "redux-persist";
import reducers from '../reducers';
import storage from "redux-persist/lib/storage";

const persistConfig = {
  key: "root",
  storage,
  blacklist: ["PageOptions", "ProductionOptions"]
}

const persistedCombinedReducers = persistCombineReducers(persistConfig,reducers);

export default function configureStore() {
    const store = createStore(persistedCombinedReducers);

    const persistor = persistStore(store);

    return {store, persistor};
}